import type { Erc20Token, Erc20Transfer, LowerHex } from '../../../types'
import type { Erc20TokenTransfer } from '../../../types/erc20'

type ParseToErc20TokenTransferParameters = {
  transfer: Erc20Transfer
  erc20Tokens: Map<LowerHex, Erc20Token>
}

export const parseToErc20TokenTransfer = ({
  transfer,
  erc20Tokens,
}: ParseToErc20TokenTransferParameters): Erc20TokenTransfer => {
  const token = erc20Tokens.get(transfer.address)
  if (token === undefined) {
    throw new Error(`Failed to get ERC20 token data: ${transfer.address}`)
  }
  return {
    ...transfer,
    token,
  }
}
